import { useEffect } from 'react';
import type { A11yState } from '../../types';
import { applyFontSize } from '../utils/apply-font-size';
import { applyTextSpacing } from '../utils/apply-text-spacing';

export function useApplyInlineStyles(
  { largeText, extraTextSpacing }: A11yState,
  elements: HTMLElement[]
) {
  useEffect(() => {
    applyFontSize(elements, !!largeText);
    applyTextSpacing(elements, !!extraTextSpacing);
  }, [elements, largeText, extraTextSpacing]);
}
